
export default function QueryFoodDataSuccess (query) {
    return {
      type: 'QUERY_FOOD_DATA_SUCCESS',
      payload: query
    };
  };
